import { useSectionAvailability } from '../../SectionGrid/hooks/useSectionAvailability';

type DisplaySectionProps<T> = {
  data: T;
  keys: (keyof T)[];
  children: React.ReactNode;
};

export const DisplaySection = <T extends object>({
  data,
  keys,
  children,
}: DisplaySectionProps<T>) => {
  const available = useSectionAvailability({
    data: data,
    props: keys,
  });

  return available ? children : null;
};
